import { Desk, Floor, Reservation, Zone } from '@ciao/console/src/swagger/models';
import { Marker } from 'leaflet';

export interface ImageDimensions {
	width: number;
	height: number;
}

export interface FloorplanReturnObject {
	destroy(): void;
	resize(): void;
	setMarkers(markers: WBMarker[]): void;
	plotDesk?(desk: Desk): void;
	unplotDesk?(desk: Desk): void;
}

// Order matters - this is how they are displayed on the legend as well
export enum MarkerStatus {
	'available',
	'partiallyAvailable',
	'checkedIn', // => becomes reserved
	'reserved',
	'unavailable',
}

export type MarkerClickCallback = (marker: WBMarker) => void | Promise<void>;
export type MarkerDragCallback = (marker: WBMarker, x: number, y: number) => void | Promise<void>;

export interface WBMarker {
	desk: Desk;
	currentReservation?: Reservation;
	reservations?: Reservation[];
	status: MarkerStatus;
	// onClick: MarkerClickCallback;i
	// onDrag: MarkerDragCallback;
	initials: string;
	marker?: Marker;
}

export interface FloorData {
	floor: Floor & { floorplanUrl: string };
	zones: Zone[];
	desks: Desk[];
}

export type Legend = {
	[key in MarkerStatus]: {
		color: string;
		label: string;
	};
};
